module.exports = __webpack_public_path__ + "static/media/logo.537211e7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brand/logo.svg
// module id = 663
// module chunks = 6